import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import useAsync from "../hooks/useAsync";
import UserServices from "../services/UserServices";

import ViewInvestor from "./View Model/ViewInvestor";
import UpdateProperty from "./Update Model/UpdateProperty";
import DeleteButton from "./Button/DeleteButton";
import UserStatus from "./TogelButton/UserStatus";
import Modal from "react-modal";
import ReactPaginate from "react-paginate";
import Pagetitle from "./PageTitle";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";
import UpdateInvestor from "./Update Model/UpdateInvestor";

Modal.setAppElement("#root");

function InvestorList() {
  const { data, error, isLoading, run } = useAsync(UserServices.getAllInvestor);
  console.log(data);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [isEditInvestorModalOpen, setIsEditInvestorModalOpen] = useState(false);
  const [selectedEditInvestor, setSelectedEditInvestor] = useState(null);
  const [userTypeFilter, setUserTypeFilter] = useState("");
  const [planFilter, setPlanFilter] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState(data?.data || []);


  const usersPerPage = 10;
  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleEditInvestorDetails = (help) => {
    setSelectedEditInvestor(help);
    setIsEditInvestorModalOpen(true);
    toggleActionMenu(null);
  };
  const closeEditInvestorModal = () => {
    setIsEditInvestorModalOpen(false);
    setSelectedEditInvestor(null);
  };
  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };
  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };
  const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  
  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
  };
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  // Define closeModal function for closing the ViewUser modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const filteredUsers = data?.data?.filter((user) => {
    const query = searchQuery?.toLowerCase() || "";
    return (
      user?.name?.toLowerCase().includes(query) ||
      user?.email?.toLowerCase().includes(query) ||
      user?.mobileNo?.toLowerCase().includes(query)
    );
  });
  

  // Calculate pagination values
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const paginatedUsers = filteredUsers?.slice(
    indexOfFirstUser,
    indexOfLastUser
  ); // Slice the filtered users for pagination

  const generateExcel = () => {
    const filteredData = filteredUsers?.map((user,index) => ({
      Sno : index+1,
      Name: user?.name,
      Email: user?.email,
      UserMobileNo: user?.mobileNo,
      Dateofbirth: user?.dateofbirth,
      City: user?.city,
      State: user?.state,
      Address: user?.address,
      Pagetitleincode: user?.pincode,
      AccountHolderName: user?.accountHolderName,
      AccountNo: user?.accountNo,
      IfscCode: user?.ifscCode,
      Pincode: user?.pincode,
      Status: user?.status,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Investor");
    XLSX.writeFile(wb, "investor.xlsx");
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box px-0 user-manager" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
        <div className="container-box-top-header px-4">
          <div className="container-box-top-header-left-2">
            <input
              type="search"
              name="search"
              placeholder="Search by Name, Email and MobileNo"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <button className="search-btn">
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>

          <div className="sub-title-box-right d-flex">
              <Link className="Add-new-btn site-btn-green me-3" to="/add-investor">
                <img src="img/add-plus.svg" alt="" />
                <span className="ms-2">Add New</span>
              </Link>
            <button
              className="excel-btn site-btn-green ms-3"
              onClick={generateExcel}
            >
              <img src="img/excel-btn.svg" alt="" />
              <span className="ms-2">Download</span>
            </button>
          </div>
        </div>
        <div className="container-box-inner">
          <table
            id="example"
            className="table table-striped table-responsive"
            style={{ width: "100%" }}
          >
            <thead>
            <tr>
              <th>S. No.</th>
              <th>Investor ID</th>
              <th>Name</th>
              <th>Email </th>
              <th>Phone </th>
              <th>Properties Owned</th>
              <th>Total Earnings</th>
              <th>Withdrawal Balance</th>
              <th>Paid Amount</th>
              <th>Status</th>
              <th>Action</th>
          </tr>
            </thead>
            <tbody>
              {paginatedUsers?.map((user, index) => (
                <tr key={user?._id}>
                  <td>{index + 1 + (currentPage - 1) * usersPerPage}</td> 
                  <td>{user?.investorId || 'N/A'}</td>
                  <td>{user?.name}</td>
                  <td>{user?.email}</td>
                  <td>{user?.mobileNo}</td>
                  <td>{user?.totalProperty}</td>
                  <td>{user?.totalEarnings}</td>
                  <td>{user?.withdrawableBalance}</td>
                  <td>{user?.totalPaidBalance}</td>
                  
                  <td className="status-toggle">
                    <UserStatus user={user} page={'investor'} onSuccess={run} />
                  </td>
                   <td>
                    <div className="action_toggle_outer">
                      <button className="action_toggle" onClick={() => toggleActionMenu(index)}>
                        <i className="fa fa-ellipsis-v" />
                      </button>
                      {activeIndex === index && (
                        <div className="action_toggle_content product-edit show d-block">
                          <ul className="list-unstyled">
                            <li>
                              <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                <i className="fa fa-close" />
                              </button>
                            </li>
                            
                            <li>
                              <button className="edit"  onClick={() => handleViewDetails(user)}>View</button>
                            </li>
                            <li>
                              <button className="edit" style={{ backgroundColor: '#F98F42' }} onClick={() => handleEditInvestorDetails(user)}>Edit</button>
                            </li>
                            <li>
                              <button className="reject" onClick={() => handleDelete(user)}>Delete</button>
                            </li>
                            <li>
                              <button className="edit"  onClick={() => handleEditDetails(user)}>Assign property</button>
                            </li>
                            
                          </ul>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}             
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredUsers?.length || 0) / usersPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            activeClassName={"active"}
            previousLabel={"Previous"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={"page-link"}
            previousLinkClassName={"page-link"}
            nextLinkClassName={"page-link"}
            pageClassName={"page-item"}
            previousClassName={"page-item"}
            nextClassName={"page-item"}
            disabledClassName={"disabled"}
          />
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewInvestor user={selectedUser} closeModal={closeModal} />
      </Modal>
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <UpdateProperty user={selectedEdit} closeModal={closeEditModal}  onSuccess={run} />
      </Modal>
      <Modal
        isOpen={isEditInvestorModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <UpdateInvestor user={selectedEditInvestor} closeModal={closeEditInvestorModal}  onSuccess={run} />
      </Modal>
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <DeleteButton
          data={selectedEdit}
          page="investor"
          closeModal={closeDeleteModal}
          onSuccess={run}
        />
      </Modal>
    </div>
  );
}

export default InvestorList;
